import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Stack } from "@/components/ui/layout";
import ScreeningTestPopup from "./ScreeningTestPopup";

const ScheduleTest = ({ onClose, open = true }) => {
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedDateTime, setSelectedDateTime] = useState("");
  const [showScreeningPopup, setShowScreeningPopup] = useState(false);

  const topics = [
    "Artificial Intelligence",
    "Full Stack Web Development",
    "Frontend Web Development",
    "React",
    "Flutter or Dart",
    "AWS DevOps",
    "Python",
    "Power BI",
    "Tableau",
    "Snowflake",
    "Data Analytics",
    "Digital Marketing",
    "Product Manager",
    "Sales",
    "Finance",
  ];

  const difficultyLevels = ["Beginner", "Intermediate", "Advanced"];

  const handleScheduleClick = () => {
    if (!selectedTopic || !selectedLevel || !selectedDateTime) {
      alert("Please select all fields before proceeding.");
      return;
    }
    setShowScreeningPopup(true);
  };

  const handleCloseScreeningPopup = () => {
    setShowScreeningPopup(false);
    onClose();
  };

  if (showScreeningPopup) {
    return <ScreeningTestPopup open={showScreeningPopup} onClose={handleCloseScreeningPopup} />;
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Schedule Test</DialogTitle>
        </DialogHeader>
        <Stack spacing="lg" className="mt-4">
          <div className="space-y-2">
            <Label htmlFor="topic">Select Topic</Label>
            <Select value={selectedTopic} onValueChange={setSelectedTopic}>
              <SelectTrigger id="topic" className="w-full">
                <SelectValue placeholder="Select Topic" />
              </SelectTrigger>
              <SelectContent>
                {topics.map((topic) => (
                  <SelectItem key={topic} value={topic}>
                    {topic}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="level">Select Level</Label>
            <Select value={selectedLevel} onValueChange={setSelectedLevel}>
              <SelectTrigger id="level" className="w-full">
                <SelectValue placeholder="Select Difficulty Level" />
              </SelectTrigger>
              <SelectContent>
                {difficultyLevels.map((level) => (
                  <SelectItem key={level} value={level}>
                    {level}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="datetime">Select Date/Time</Label>
            <input
              id="datetime"
              type="datetime-local"
              value={selectedDateTime}
              onChange={(e) => setSelectedDateTime(e.target.value)}
              className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
            />
          </div>

          <Button
            onClick={handleScheduleClick}
            className="w-full mt-4"
            size="lg"
          >
            Get Schedule Test Link
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleTest;
